import preprocessResponse from 'ha/utils/preprocessResponse';

export default function createTranslationService(
  { languageDetectionURL },
  fetchClient,
) {
  return {
    detectLanguage: string =>
      fetchClient
        .fetch(languageDetectionURL, {
          method: 'POST',
          mode: 'cors',
          body: string,
        })
        .then(preprocessResponse)
        .then(({ lang }) => lang),
  };
}
